import Awaiters from "../../../LTGame/Async/Awaiters";
import LTList from "../../../LTGame/LTUtils/LTList";
import { LTUtils } from "../../../LTGame/LTUtils/LTUtils";
import MathEx from "../../../LTGame/LTUtils/MathEx";
import { TransformEx } from "../../../LTGame/LTUtils/TransformEx";
import Vector3Ex from "../../../LTGame/LTUtils/Vector3Ex";
import { P2Manager } from "../../../LTGame/Physics/P2Manager";
import LTRes from "../../../LTGame/Res/LTRes";
import { ELoadTye } from "../../common/ELoadType";
import GlobalUnit from "../../common/GlobalUnit";
import LayerDefine from "../../common/LayerDefine";
import ResDefine from "../../common/ResDefine";
import { GameConst } from "../../config/GameConst";
import { ItemConfig } from "../../config/ItemConfig";
import { RoleConfig } from "../../config/RoleConfig";
import { RoleGroup } from "../../config/RoleGroup";
import AudioManager from "../../manager/AudioManager";
import { UI_FightMediator } from "../../ui/UI_FightMediator";
import { EAnimType } from "../CameraControl";
import { ELevelPoint } from "../ViewLevel";
import ViewPlayer from "./ViewPlayer";
const Queue_Fight = [
    [29, 28, 30],
    [27, 17, 16, 18, 26],
    [19, 5, 4, 8, 20],
    [9, 1, 0, 2, 11],
    [14, 6, 3, 7, 15],
    [21, 12, 10, 13, 22],
    [34, 24, 23, 25, 35],
    [32, 31, 33]
];
const Boss_Fight = [
    [7, 5, 3, 1, 0, 2, 4, 6, 8],
    [16, 14, 12, 10, 9, 11, 13, 15, 17],
    [25, 23, 21, 19, 18, 20, 22, 24, 26],
    [34, 32, 30, 28, 27, 29, 31, 33, 35]
];
export var EPlayerState;
(function (EPlayerState) {
    EPlayerState[EPlayerState["Idle"] = 0] = "Idle";
    EPlayerState[EPlayerState["Fight"] = 1] = "Fight";
    EPlayerState[EPlayerState["EndFight"] = 2] = "EndFight";
    EPlayerState[EPlayerState["Jump"] = 3] = "Jump";
    EPlayerState[EPlayerState["Die"] = 4] = "Die";
})(EPlayerState || (EPlayerState = {}));
export default class PlayerLogic {
    constructor() {
        this.Inited = false;
        this._cacheXSpeed = [0];
    }
    Init(root, trans) {
        this.rootObj = new Laya.Sprite3D("palyerContent");
        root.addChild(this.rootObj);
        this.cacheOriginX = trans.position.x;
        TransformEx.CopyTrans(this.rootObj.transform, trans);
        this.InitSkillData();
        this.playerList = new LTList();
        this.ammoList = new LTList();
        GlobalUnit.game.camera.SetFrom(this.rootObj);
        this.state = EPlayerState.Idle;
        this.targetMoveX = this.rootObj.transform.position.x;
        this.CreateBody();
        this.AddMore(this.InitPlayerCount);
        this.InitPet();
    }
    SetPlayerId(id) {
        this.config = RoleGroup.data[id];
    }
    PreLoad(urls) {
        let len = this.config.rids.length;
        for (let i = 0; i < len; ++i) {
            let id = this.config.rids[i];
            let config = RoleConfig.data[id];
            urls.push(ResDefine.FixPath(config.role_model));
            urls.push(ResDefine.FixPath(config.ammo_model));
        }
    }
    UnLoadConfig() {
        let len = this.config.rids.length;
        for (let i = 0; i < len; ++i) {
            let id = this.config.rids[i];
            let config = RoleConfig.data[id];
            LTRes.Unload(ResDefine.FixPath(config.role_model));
            LTRes.Unload(ResDefine.FixPath(config.ammo_model));
        }
    }
    InitPet() {
        GlobalUnit.game.pet.CreatePet(this);
    }
    InitSkillData() {
        this.superTime = 0;
        this.skills = {};
        this.maxYear = this.currYear = GlobalUnit.dataManager.GetSkillConfig(0).skill_value;
        console.log("lv type" + GlobalUnit.game.level.config.level_type);
        if (GlobalUnit.game.level.config.level_type == 4) {
            this.maxPlayer = this.InitPlayerCount = 1;
            this.currIndex = 0;
        }
        else {
            this.maxPlayer = this.InitPlayerCount = GlobalUnit.dataManager.GetSkillConfig(1).skill_value;
            this.currIndex = this.GetCurrIndex();
        }
        this.fire_rate = GlobalUnit.dataManager.GetSkillConfig(2).skill_value / 100;
        this.damage_rate = GlobalUnit.dataManager.GetSkillConfig(3).skill_value / 100;
    }
    UpgradePlayerYear() {
        this.currYear = GlobalUnit.dataManager.GetSkillConfig(0).skill_value;
        this.UpdateIndex();
    }
    UpgradePlayerCount() {
        let count = GlobalUnit.dataManager.GetSkillConfig(1).skill_value;
        this.AddMore(count - this.InitPlayerCount);
        this.InitPlayerCount = count;
    }
    UpgradeFireRate() {
        this.fire_rate = GlobalUnit.dataManager.GetSkillConfig(2).skill_value / 100;
        this.UpdateFireRate();
    }
    UpgradeDamageRate() {
        this.damage_rate = GlobalUnit.dataManager.GetSkillConfig(3).skill_value / 100;
    }
    GetRootPos() {
        if (this.state == EPlayerState.Die || !this.rootObj.transform.position)
            return new Laya.Vector3();
        return this.rootObj.transform.position;
    }
    CreateBody() {
        this.body = P2Manager.instance.CreateCircleBody(0.3, this.rootObj.transform.position);
        this.body.shapes[0].collisionGroup = LayerDefine.Root;
        this.body.shapes[0].collisionMask = LayerDefine.Door;
        this.body.shapes[0].type = p2.Body.DYNAMIC;
        this.body["use"] = this;
        P2Manager.instance.AddBody(this.body);
    }
    SyncPos() {
        P2Manager.instance.SyncTransToRigXZ(this.rootObj.transform, this.body);
    }
    GetSkill(id) {
        let skill = this.skills[id] || 1;
        switch (skill) {
            case 1:
                skill *= this.fire_rate;
                break;
            case 2:
                skill *= this.damage_rate;
                break;
        }
        return skill;
    }
    BeginContact(other) {
        if (other.config.item_type != 1
            && other.config.item_type != 2)
            return;
        let types = other.types;
        let config = ItemConfig.data[types[0]];
        if (config.item_type == 1 || config.item_type == 2) {
            let now = Date.now();
            if (this.lastTiggerDoorTime && now - this.lastTiggerDoorTime < 300) {
                return;
            }
            this.lastTiggerDoorTime = now;
        }
        LTUtils.Vibrate(false);
        let sign = types[2];
        if (sign == 1 || sign == 3) {
            AudioManager.instance.PlayById(3);
        }
        else {
            AudioManager.instance.PlayById(4);
        }
        if (config.item_type == 1) {
            /**
             * 年 == 1   日 == 2  人 == 3 月 == 4
             */
            let type = types[1];
            /**
             * 1 2 3 4 == 加减乘除
             */
            let sign = types[2];
            let value = types[3];
            this.ChangeAttributes(type, sign, value);
            other.Destroy();
        }
        else if (config.item_type == 2) {
            /**
             * 攻速 == 1   伤害 == 2
             */
            let type = types[1];
            let sign = types[2];
            let value = types[3];
            var count = this.skills[type];
            if (!count) {
                count = 1;
            }
            var newValue = this.CountSign(count, sign, value);
            this.skills[type] = newValue;
            switch (type) {
                case 1:
                    this.UpdateFireRate();
                    break;
                case 2:
                    break;
            }
            other.Destroy();
        }
    }
    JumpLevel(levelId, trans) {
        return __awaiter(this, void 0, void 0, function* () {
            this.state = EPlayerState.Jump;
            for (let i = 0; i < this.playerList.Count; i++) {
                this.playerList.Get(i).PlayMoveToBlack(trans);
            }
            yield Awaiters.Seconds(1);
            yield GlobalUnit.game.CreateLevel(ELoadTye.Try, levelId);
            GlobalUnit.game.StartGame();
        });
    }
    ChangeAttributes(type, sign, value) {
        switch (type) {
            case 1:
                var count = this.currYear;
                var newValue = this.CountSign(count, sign, value);
                newValue -= count;
                this.UpdateYear(newValue);
                break;
            case 2:
                var count = this.currYear;
                if (sign == 1 || sign == 2) {
                    count = 0;
                    value /= 360;
                }
                var newValue = this.CountSign(count, sign, value);
                newValue -= count;
                this.UpdateYear(newValue);
                break;
            case 3:
                var count = this.playerList.Count;
                var newValue = this.CountSign(count, sign, value);
                newValue = Math.ceil(newValue);
                newValue -= count;
                if (newValue > 0) {
                    this.AddMore(newValue);
                }
                else if (newValue < 0) {
                    this.SubMore(Math.abs(newValue));
                }
                break;
            case 4:
                var count = this.currYear;
                if (sign == 1 || sign == 2) {
                    count = 0;
                    value /= 12;
                }
                var newValue = this.CountSign(count, sign, value);
                newValue -= count;
                this.UpdateYear(newValue);
                break;
        }
    }
    UpdateFireRate() {
        for (let i = 0; i < this.playerList.Count; ++i) {
            this.playerList.Get(i).UpdateAnimScale();
        }
    }
    CountSign(origin, sign, value) {
        let count = 0;
        /** 加减乘除 */
        if (sign == 1) {
            count = origin + value;
        }
        else if (sign == 2) {
            count = origin - value;
        }
        else if (sign == 3) {
            count = origin * value;
        }
        else if (sign == 4) {
            count = origin / value;
        }
        return count;
    }
    UpdateDay(value) {
        this.UpdateYear(value / 360);
    }
    UpdateMonth(value) {
        this.UpdateYear(value / 12);
    }
    UpdateYear(value) {
        this.currYear += value;
        if (this.currYear < 0) {
            this.currYear = 0;
        }
        if (this.currYear > this.maxYear) {
            this.maxYear = this.currYear;
        }
        this.UpdateIndex();
        if (UI_FightMediator.instance.isShow) {
            UI_FightMediator.instance.UpdateBarValue();
        }
    }
    GetCurrIndex() {
        let newIndex = 0;
        let len = GameConst.data.yearToPlayerId.length;
        for (let i = len - 1; i >= 0; i--) {
            if (this.currYear >= GameConst.data.yearToPlayerId[i]) {
                newIndex = i;
                break;
            }
        }
        return newIndex;
    }
    UpdateIndex() {
        let newIndex = this.GetCurrIndex();
        if (this.currIndex != newIndex) {
            if (this.currIndex < newIndex) {
                AudioManager.instance.PlayById(5);
            }
            for (let i = 0; i < this.playerList.Count; i++) {
                this.playerList.Get(i).PlayerEff("up");
            }
            this.currIndex = newIndex;
            this.ChangeModel();
        }
    }
    UpdateIndexForce(newIndex) {
        if (this.currIndex != newIndex) {
            if (this.currIndex < newIndex) {
                AudioManager.instance.PlayById(5);
            }
            for (let i = 0; i < this.playerList.Count; i++) {
                this.playerList.Get(i).PlayerEff("up");
            }
            this.currIndex = newIndex;
            this.ChangeModel();
        }
    }
    AddMore(value) {
        for (let i = 0; i < value; i++) {
            this.AddPlayer();
            if (this.playerList.Count > 35)
                break;
        }
        this.UpdatePlayerLocalPos();
        for (let i = 0; i < this.playerList.Count; i++) {
            this.playerList.Get(i).PlayerEff("change");
        }
    }
    SubMore(value) {
        for (let i = 0; i < value; i++) {
            let count = this.playerList.Count;
            if (count <= 0)
                break;
            let player = this.playerList.Get(count - 1);
            this.RemovePlayer(player);
            player.OnDie();
        }
        this.UpdatePlayerLocalPos();
        for (let i = 0; i < this.playerList.Count; i++) {
            this.playerList.Get(i).PlayerEff("change");
        }
    }
    SetToOne() {
        for (let i = this.playerList.Count - 1; i > 0; i--) {
            let player = this.playerList.Get(i);
            this.RemovePlayer(player);
            // player.OnDie();
            player.model.active = false;
        }
        this.UpdatePlayerLocalPos();
        // for (let i = 0; i < this.playerList.Count; i++) {
        //     this.playerList.Get(i).PlayerEff("change");
        // }
    }
    AddPlayer() {
        let config = RoleConfig.data[this.config.rids[this.currIndex]];
        let player = new ViewPlayer(config, this.rootObj);
        switch (this.state) {
            case EPlayerState.Idle:
                player.OnIdle();
                break;
            case EPlayerState.Fight:
                player.OnStart();
                break;
            case EPlayerState.EndFight:
                player.OnFighted();
                break;
        }
        this.playerList.UnShift(player);
    }
    UpdatePlayerLocalPos() {
        let list = Queue_Fight;
        if (this.state == EPlayerState.EndFight) {
            list = Boss_Fight;
        }
        let w = GameConst.data.roleDistance;
        let h = GameConst.data.z_roleDistance;
        let count = this.playerList.Count;
        if (count > this.maxPlayer) {
            this.maxPlayer = count;
        }
        let max = 0;
        let index = 0;
        let posList = [];
        let indexs = [];
        let point = GlobalUnit.game.level.GetLevelPoint(ELevelPoint.End);
        let subtract = Vector3Ex.Subtract(point.transform.position, this.rootObj.transform.position);
        // subtract = Vector3Ex.Scale(subtract, 0.5);
        for (let i = 0; i < list.length; ++i) {
            let arrTemp = [];
            for (let j = 0; j < list[i].length; ++j) {
                let index = list[i][j];
                if (index > count - 1)
                    continue;
                let temp = this.playerList.Get(index);
                indexs.push(index);
                arrTemp.push(temp);
            }
            let y = -index * h;
            if (arrTemp.length > 0) {
                index++;
            }
            let len = arrTemp.length;
            if (len > max)
                max = len;
            for (let k = 0; k < len; ++k) {
                let offset = GameConst.data.role_dist_random;
                let vec3 = new Laya.Vector3();
                vec3.x = k * w - len * w / 2 + w / 2 + MathEx.Random(-offset, offset);
                vec3.z = y + MathEx.Random(-offset, offset);
                if (this.state == EPlayerState.EndFight) {
                    vec3 = Vector3Ex.Add(vec3, subtract);
                    vec3.z += 1;
                }
                posList.push(vec3);
            }
        }
        let len = posList.length;
        for (let i = 0; i < len; ++i) {
            let pos = posList.pop();
            let cacheDist = Number.MAX_VALUE;
            let cacheIndex = 0;
            for (let j = 0; j < indexs.length; ++j) {
                let temp = this.playerList.Get(indexs[j]);
                let dist = Vector3Ex.Distance2D(temp.offset, pos);
                if (dist < cacheDist) {
                    cacheDist = dist;
                    cacheIndex = j;
                }
            }
            this.playerList.Get(indexs[cacheIndex]).offset = pos;
            indexs.splice(cacheIndex, 1);
        }
        this.landscapeCount = max;
    }
    ChangeSkin(id) {
        return __awaiter(this, void 0, void 0, function* () {
            this.SetPlayerId(id);
            let urls = [];
            this.PreLoad(urls);
            yield LTRes.LoadAsync(urls);
            this.ChangeModel();
        });
    }
    ChangeModel() {
        let count = this.playerList.Count;
        let config = RoleConfig.data[this.config.rids[this.currIndex]];
        for (let i = 0; i < count; ++i) {
            let player = this.playerList.Get(i);
            player.ChangeModel(config);
        }
        for (let i = 0; i < this.playerList.Count; i++) {
            this.playerList.Get(i).PlayerEff("change");
        }
    }
    CheckClampX(x) {
        let w = 10 / 2;
        let playerWidth = this.landscapeCount * GameConst.data.roleDistance / 2;
        let min = this.cacheOriginX - w + playerWidth;
        let max = this.cacheOriginX + w - playerWidth;
        if (x < min) {
            x = min;
            this.targetMoveX = x;
        }
        if (x > max) {
            x = max;
            this.targetMoveX = x;
        }
        return x;
    }
    RemovePlayer(player) {
        this.playerList.Remove(player);
    }
    DelayUpdatePos() {
        this._blnUpdate = true;
        this._updateTime = Date.now() + GameConst.data.dealy_updatepos_time;
    }
    CheckUpdatePos() {
        if (this._blnUpdate) {
            let time = Date.now();
            if (time >= this._updateTime) {
                this._blnUpdate = false;
                this.UpdatePlayerLocalPos();
            }
        }
    }
    GetPlayerByDistance(pos) {
        let dist = Number.MAX_VALUE;
        let obj;
        for (let i = 0; i < this.playerList.Count; i++) {
            let player = this.playerList.Get(i);
            let num = Vector3Ex.Distance2D(player.model.transform.position, pos);
            if (num < dist) {
                dist = num;
                obj = player;
            }
        }
        return obj;
    }
    StartGame() {
        GlobalUnit.game.camera.SetAnim(EAnimType.Fight);
        this.state = EPlayerState.Fight;
        for (let i = 0; i < this.playerList.Count; ++i) {
            this.playerList.Get(i).OnStart();
        }
    }
    OnSuper() {
        this.superTime = Number.MAX_VALUE;
    }
    OnMove(dt) {
        let dragPercent = UI_FightMediator.instance.xDragCmp.xOffset / Laya.stage.width;
        this.targetMoveX -= dragPercent * GameConst.data.x_move_speed;
        let old = this.rootObj.transform.position;
        old.z += GameConst.data.z_move_speed * dt;
        let x = MathEx.SmoothDamp(old.x, this.targetMoveX, this._cacheXSpeed, GameConst.data.smooth_time, GameConst.data.max_speed, dt);
        old.x = this.CheckClampX(x);
        this.rootObj.transform.position = old;
        let point = GlobalUnit.game.level.GetLevelPoint(ELevelPoint.End);
        if (old.z >= point.transform.position.z) {
            this.state = EPlayerState.EndFight;
            this.UpdatePlayerLocalPos();
            for (let i = 0; i < this.playerList.Count; i++) {
                this.playerList.Get(i).BeginEd();
            }
            UI_FightMediator.instance.HideBar();
            GlobalUnit.game.level.PlayFighted();
            GlobalUnit.game.camera.SetAnim(EAnimType.Fighted);
        }
    }
    OnRevive() {
        this.superTime = GameConst.data.revive_super_time;
        this.currYear = this.maxYear;
        this.AddMore(this.maxPlayer);
    }
    AddAmmo(ammo) {
        this.ammoList.Add(ammo);
    }
    RemoveAmmo(ammo) {
        this.ammoList.Remove(ammo);
    }
    GetHaveSuper() {
        return this.superTime > 0 ? true : false;
    }
    Clear() {
        for (let i = this.playerList.Count - 1; i > 0; i--) {
            let player = this.playerList.Get(i);
            this.RemovePlayer(player);
            // player.OnDie();
            player.model.active = false;
        }
        this.playerList.Clear();
    }
    Update(dt) {
        if (this.rootObj.destroyed)
            return;
        if (this.state == EPlayerState.Fight) {
            this.superTime -= dt;
            this.CheckUpdatePos();
            this.OnMove(dt);
            this.SyncPos();
            for (let i = 0; i < this.playerList.Count; ++i) {
                this.playerList.Get(i).Update(dt);
            }
        }
        else if (this.state == EPlayerState.EndFight) {
            // this.rootObj.transform.localPositionX = MathEx.Lerp(this.rootObj.transform.localPositionX, 0,0.1);
            this.SyncPos();
            for (let i = 0; i < this.playerList.Count; ++i) {
                this.playerList.Get(i).Update(dt);
            }
        }
        else if (this.state == EPlayerState.Jump) {
        }
        else {
            for (let i = 0; i < this.playerList.Count; ++i) {
                this.playerList.Get(i).LerpPos();
            }
        }
        // this.UpdateAmmo();
    }
    UpdateAmmo(dt) {
        for (let i = 0; i < this.ammoList.Count; ++i) {
            this.ammoList.Get(i).Update(dt);
        }
    }
    LateUpdate(dt) {
        if (this.playerList.Count <= 0) {
            return false;
        }
        return true;
    }
}
